<template>

    <section>
        <!-- ここから -->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            Heading
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <h1 class="heading_page-title flex _y-center">
            <div class="main"><span>プラン選択</span></div>
        </h1><!--/.heading_page-title-->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            DashBoardCardWrap
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="card_plan-select-container">
            <div class="card_plan-select-wrap">

                <!--Card-->
                <div class="card">
                    <div class="title"><p class="main"><span>Free</span></p></div>
                    <div class="price">
                        <span>0</span>
                        <div>/ 月</div>
                    </div>
                    <div class="comment">
                        <p>無料なので誰でも簡単登録</p>
                    </div>
                    <ul>
                        <li><span>商品ブランドの紹介</span></li>
                        <li class="_disable"><span>Price Image10枚登録可能</span></li>
                        <li class="_disable"><span>制作スタッフの紹介</span></li>
                        <li class="_disable"><span>ハッシュタグ検索</span></li>
                        <li class="_disable"><span>電話又はメールのお問い合わせ機能搭載</span></li>
                        <li class="_disable"><span>マイセレクトルーム（お気に入り機能）でビジネス対象のリスト確認ができる</span></li>
                        <li class="_disable"><span>チャット機能でショップへ情報の発信可能</span></li>
                    </ul>
                    <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>Freeアカウントで登録する</span>
                        </div>
                    </Link>
                </div><!--/.Card-->

                <!--Card-->
                <div class="card _main">
                    <div class="title"><p class="main"><span>BASIC</span></p></div>
                    <div class="price">
                        <span>4,950</span>
                        <div>/ Month</div>
                    </div>
                    <div class="comment">
                        <p>ビジネスに繋がる情報掲載！販促予算の無い方におすすめ。マイセレクトルームで、ショップ側からのアプローチが実現！チャット機能で展示会情報やショップ側の情報などを確認できます。</p>
                    </div>
                    <ul>
                        <li><span>商品ブランドの紹介</span></li>
                        <li><span>Price Image10枚登録可能</span></li>
                        <li><span>制作スタッフの紹介</span></li>
                        <li><span>ハッシュタグ検索</span></li>
                        <li><span>電話又はメールのお問い合わせ機能搭載</span></li>
                        <li><span>マイセレクトルーム（お気に入り機能）でビジネス対象のリスト確認ができる</span></li>
                        <li><span>チャット機能でショップへ情報の発信可能</span></li>
                    </ul>
                    <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>Basicアカウントで登録する</span>
                        </div>
                    </Link>
                </div><!--/.Card-->

                <!--Card-->
                <div class="card _soon">
                    <div class="title">
                        <p class="main"><span>Premium</span></p>
                        <p class="sub">Coming Soon</p>
                    </div>
                </div><!--/.Card-->

            </div><!--/.card_plan-select-->
        </div><!--/.DashBoardCardWrap-->

        <!-- ここまで -->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            Heading
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <h1 class="heading_page-title flex _y-center" style="margin-top: 8rem;">
            <div class="main"><span>プラン選択</span></div>
            <p>ボタンのスタイルは崩れてますがエンドユーザー側画面に持っていけばスタイルが当たります。</p>
        </h1><!--/.heading_page-title-->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            DashBoardCardWrap
            2/25追加ここから
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="card_plan-select-container">
            <div class="card_plan-select-wrap _add-gap">

                <!--Card-->
                <div class="card">
                    <div class="title">
                        <p class="main"><span>Unit</span></p>
                        <p class="sub"><span>ユニットアカウント（法人利用）</span></p>
                    </div>
                    <div class="price">
                        <span>0</span>
                        <div>/ 月</div>
                    </div>
                    <div class="recommend">
                        <span>ショップ / テナント運営</span>
                    </div>
                    <ul>
                        <li><span>ショップの紹介ページの作成</span></li>
                        <li><span>Price Image10枚登録可能</span></li>
                        <li><span>ビジネス取引詳細</span></li>
                        <li><span>制作スタッフの紹介</span></li>
                        <li><span>ハッシュタグ検索</span></li>
                        <li><span>マイセレクトルーム（お気に入り機能）でビジネス対象のリスト確認ができる</span></li>
                        <li><span>チャット機能でショップへ情報の発信可能</span></li>
                        <li><span>各種ショップ・飲食・サロン・ギャラリー・宿泊事業運営者・バイヤー・コーディネーター・テナントリーシング・インフルエンサーの方などに最適</span></li>
                    </ul>
                    <a href="" class="btn_link-wrap _w100">
                        <button type="button" class="btn_link"><span>UNITで登録する</span></button>
                        <div class="bg-element"></div>
                    </a>
                </div><!--/.Card-->

                <!--Card-->
                <div class="card">
                    <div class="title">
                        <p class="main"><span>Personal</span></p>
                        <p class="sub"><span>パーソナルアカウント（個人利用）</span></p>
                    </div>
                    <div class="price">
                        <span>0</span>
                        <div>/ 月</div>
                    </div>
                    <div class="recommend">
                        <span>一般 / 学生</span>
                    </div>
                    <ul>
                        <li><span>ショップの紹介ページの作成</span></li>
                        <li><span>Price Image10枚登録可能</span></li>
                        <li><span>ビジネス取引詳細</span></li>
                        <li><span>制作スタッフの紹介</span></li>
                        <li><span>ハッシュタグ検索</span></li>
                        <li><span>マイセレクトルーム（お気に入り機能）でビジネス対象のリスト確認ができる</span></li>
                        <li><span>マイセレクトルーム（お気に入り機能）でビジネス対象のリスト確認ができる</span></li>
                        <li><span>チャット機能でショップへ情報の発信可能</span></li>
                    </ul>
                    <a href="" class="btn_link-wrap _w100">
                        <button type="button" class="btn_link"><span>PERSONALで登録する</span></button>
                        <div class="bg-element"></div>
                    </a>
                </div><!--/.Card-->

            </div><!--/.card_plan-select-->
        </div><!--/.DashBoardCardWrap-->

        <!-- 2/25追加ここまで -->

    </section>

</template>


<script>

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        components: {
            SvgIconCheck,
        },
    }
</script>

